const getDefaultState = () => {
  return {
    nowIndex: 0
  }
}

const state = getDefaultState()

const mutations = {
  SET_NOWINDEX: (state, index) => {
    state.nowIndex = index
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

